
import { Sparkles } from "lucide-react";

interface AIDescriptionPanelProps {
  explanation: string;
}

export const AIDescriptionPanel = ({ explanation }: AIDescriptionPanelProps) => {
  return (
    <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
      <div className="flex items-center gap-2 mb-2">
        <Sparkles className="w-4 h-4 text-blue-600" />
        <span className="text-sm font-medium text-blue-800">AI Description:</span>
      </div>
      <p className="text-sm text-blue-800">{explanation}</p>
    </div>
  );
};
